"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3074],{

/***/ 33074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48080);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27429);








var CartPreview = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(__webpack_require__.e(/* import() */ 4972).then(__webpack_require__.bind(__webpack_require__, 44972)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44972)
            ];
        }
    }
});
var PreviewContent = function(param) {
    var cart = param.cart, lineItems = param.lineItems, onClose = param.onClose, onUpdateCart = param.onUpdateCart, removeCoupon = param.removeCoupon, visible = param.visible;
    var mainDivRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), qtyErrorId = ref[0], setQtyErrorId = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), couponError = ref1[0], setCouponError = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(event) {
            var ref;
            var clickOutsideExpandedMenu = (mainDivRef === null || mainDivRef === void 0 ? void 0 : mainDivRef.current) ? !(mainDivRef === null || mainDivRef === void 0 ? void 0 : (ref = mainDivRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target)) : true;
            if (clickOutsideExpandedMenu) {
                event.stopPropagation();
                onClose();
            }
        };
        // Bind the event listener
        if (visible) {
            document.addEventListener("click", handleClickOutside);
            document.addEventListener("touchend", handleClickOutside);
        }
        return function() {
            try {
                document.removeEventListener("click", handleClickOutside);
                document.removeEventListener("touchend", handleClickOutside);
            } catch (e) {
            // Do nothing
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mainDivRef,
        visible
    ]);
    var onUpdate = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var id, quantity, ref, ref1, ref2, cartUpdateQuantity, checkIsExtendItem, productUpdateGA, event, cartItemToExecuteAction, productId, variantId, lineItem, response, cartItemAfterActionExecuted, ref3;
            return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id, quantity = param.quantity;
                        ;
                        _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                        _ctx.next = 5;
                        return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                            return [
                                __webpack_require__.e(/* import() */ 1023).then(__webpack_require__.bind(__webpack_require__, 31023)),
                                Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 40136)),
                                Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 32054)), 
                            ];
                        });
                    case 5:
                        _ctx.t1 = _ctx.sent;
                        ref1 = (0, _ctx.t0)(_ctx.t1, 3);
                        ref2 = ref1[0];
                        cartUpdateQuantity = ref2.default;
                        checkIsExtendItem = ref1[1].checkIsExtendItem;
                        productUpdateGA = ref1[2].productUpdateGA;
                        event = "addToCart";
                        if (cart) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 14:
                        setQtyErrorId("");
                        cartItemToExecuteAction = cart.lineItems.find(function(item) {
                            return item.id === id;
                        });
                        productId = cartItemToExecuteAction === null || cartItemToExecuteAction === void 0 ? void 0 : cartItemToExecuteAction.productId;
                        variantId = cartItemToExecuteAction === null || cartItemToExecuteAction === void 0 ? void 0 : cartItemToExecuteAction.variantId;
                        lineItem = lineItems.find(function(item) {
                            return item.id === id;
                        });
                        if (!(lineItem && checkIsExtendItem(lineItem))) {
                            _ctx.next = 21;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 21:
                        _ctx.next = 23;
                        return cartUpdateQuantity({
                            cartId: cart === null || cart === void 0 ? void 0 : cart.id,
                            itemId: id,
                            quantity: quantity,
                            productId: productId,
                            variantId: variantId
                        });
                    case 23:
                        response = _ctx.sent;
                        (0,_services_Log__WEBPACK_IMPORTED_MODULE_5__/* .log */ .cM)("CartPreview: Cart updated", {
                            response: response
                        });
                        cartItemAfterActionExecuted = response === null || response === void 0 ? void 0 : (ref = response.newCart) === null || ref === void 0 ? void 0 : ref.lineItems.find(function(item) {
                            return item.id === id;
                        });
                        (0,_services_Log__WEBPACK_IMPORTED_MODULE_5__/* .log */ .cM)("cartItemAfterActionExecuted", {
                            cartItemAfterActionExecuted: cartItemAfterActionExecuted,
                            lineItem: lineItem,
                            cartItemToExecuteAction: cartItemToExecuteAction
                        });
                        if (response.newCart) {
                            onUpdateCart(response.newCart);
                        }
                        if (response.success && cartItemAfterActionExecuted) {
                            ;
                            productUpdateGA(cartItemAfterActionExecuted, event, ((ref3 = response.newCart) === null || ref3 === void 0 ? void 0 : ref3.total) || 0);
                        }
                        if (!response.success || (cartItemAfterActionExecuted === null || cartItemAfterActionExecuted === void 0 ? void 0 : cartItemAfterActionExecuted.quantity) !== quantity) {
                            (0,_services_Log__WEBPACK_IMPORTED_MODULE_5__/* .log */ .cM)("CartPreview: Cart update failed", {
                                response: response,
                                cartItemAfterActionExecuted: cartItemAfterActionExecuted,
                                lineItem: lineItem,
                                cartItemToExecuteAction: cartItemToExecuteAction,
                                quantity: quantity
                            });
                            setQtyErrorId(id);
                        }
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onUpdate(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var sendEventToGA = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(currentCartItem) {
            var ref, getCart, productGA, initialCart;
            return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                        _ctx.next = 3;
                        return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                            return [
                                Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(8309), __webpack_require__.e(8764), __webpack_require__.e(6511), __webpack_require__.e(8741)]).then(__webpack_require__.bind(__webpack_require__, 36511)),
                                __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 66778)), 
                            ];
                        });
                    case 3:
                        _ctx.t1 = _ctx.sent;
                        ref = (0, _ctx.t0)(_ctx.t1, 2);
                        getCart = ref[0].getCart;
                        productGA = ref[1].productGA;
                        _ctx.next = 9;
                        return getCart();
                    case 9:
                        initialCart = _ctx.sent;
                        productGA({
                            name: currentCartItem.name,
                            sku: currentCartItem.sku,
                            price: "".concat(currentCartItem.subtotalPrice || currentCartItem.subtotalPrice),
                            salePrice: currentCartItem.salePrice,
                            variantId: currentCartItem.variantId,
                            categories: [],
                            event: "deleteFromCart",
                            brand: currentCartItem.brand,
                            quantity: 1,
                            cartTotal: (initialCart === null || initialCart === void 0 ? void 0 : initialCart.total) || 0
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendEventToGA(currentCartItem) {
            return _ref.apply(this, arguments);
        };
    }();
    var onDelete = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var id, quantity, ref, ref1, cartDeleteItem, cartItemToExecuteAction, productId, variantId, response;
            return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id, quantity = param.quantity;
                        _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                        _ctx.next = 4;
                        return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                            return [
                                __webpack_require__.e(/* import() */ 5149).then(__webpack_require__.bind(__webpack_require__, 67599))
                            ];
                        });
                    case 4:
                        _ctx.t1 = _ctx.sent;
                        ref = (0, _ctx.t0)(_ctx.t1, 1);
                        ref1 = ref[0];
                        cartDeleteItem = ref1.default;
                        if (cart) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 10:
                        setQtyErrorId("");
                        cartItemToExecuteAction = cart.lineItems.find(function(item) {
                            return item.id === id;
                        });
                        if (cartItemToExecuteAction) {
                            _ctx.next = 15;
                            break;
                        }
                        setQtyErrorId(id);
                        return _ctx.abrupt("return");
                    case 15:
                        sendEventToGA(cartItemToExecuteAction).catch(_services_Log__WEBPACK_IMPORTED_MODULE_5__/* .error */ .vU);
                        productId = cartItemToExecuteAction === null || cartItemToExecuteAction === void 0 ? void 0 : cartItemToExecuteAction.productId;
                        variantId = cartItemToExecuteAction === null || cartItemToExecuteAction === void 0 ? void 0 : cartItemToExecuteAction.variantId;
                        _ctx.next = 20;
                        return cartDeleteItem({
                            cartId: cart === null || cart === void 0 ? void 0 : cart.id,
                            itemId: id,
                            quantity: quantity,
                            productId: productId,
                            variantId: variantId
                        });
                    case 20:
                        response = _ctx.sent;
                        if (response.success) {
                            onUpdateCart(response.newCart);
                        } else {
                            setQtyErrorId(id);
                        }
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onDelete(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var onCouponSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(couponCode) {
            var ref, applyCoupon, getCart, data, ref1;
            return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setCouponError("");
                        _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                        _ctx.next = 4;
                        return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                            return [
                                __webpack_require__.e(/* import() */ 1198).then(__webpack_require__.bind(__webpack_require__, 71198)),
                                Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(8309), __webpack_require__.e(8764), __webpack_require__.e(6511), __webpack_require__.e(8741)]).then(__webpack_require__.bind(__webpack_require__, 36511)), 
                            ];
                        });
                    case 4:
                        _ctx.t1 = _ctx.sent;
                        ref = (0, _ctx.t0)(_ctx.t1, 2);
                        applyCoupon = ref[0].applyCoupon;
                        getCart = ref[1].getCart;
                        _ctx.next = 10;
                        return applyCoupon(couponCode);
                    case 10:
                        data = _ctx.sent;
                        if (!(data.status === "success")) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.t2 = onUpdateCart;
                        _ctx.next = 15;
                        return getCart();
                    case 15:
                        _ctx.t3 = _ctx.sent;
                        (0, _ctx.t2)(_ctx.t3);
                        _ctx.next = 20;
                        break;
                    case 19:
                        {
                            ;
                            setCouponError(data === null || data === void 0 ? void 0 : (ref1 = data.errors) === null || ref1 === void 0 ? void 0 : ref1[0]);
                        }
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onCouponSubmit(couponCode) {
            return _ref.apply(this, arguments);
        };
    }();
    return !visible || !cart ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                id: "backOfcartPreview",
                className: "md:hidden fixed top-0 left-0 bg-backdrop-light bg-opacity-80 w-screen h-screen"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "hidden md:block w-6 h-1 absolute top-8 right-0",
                style: {
                    backgroundColor: "#3B5F58"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                ref: mainDivRef,
                className: "cartPreview z-500",
                "data-dropdown-content": "true",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CartPreview, {
                    checkoutLink: "/checkout/shipping",
                    id: "cartPreview",
                    label: "Cart Preview",
                    lineItems: lineItems,
                    onQtyChange: function() {},
                    onQtyDelete: onDelete,
                    onQtyUpdate: onUpdate,
                    onUpdateCart: onUpdateCart,
                    onClose: onClose,
                    qtyError: "Sorry we do not have enough stock for the quantity you have selected.",
                    qtyErrorId: qtyErrorId,
                    onCouponSubmit: onCouponSubmit,
                    onRemoveCoupon: removeCoupon,
                    couponError: couponError,
                    clearCouponError: function() {
                        return setCouponError("");
                    },
                    cart: cart
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PreviewContent);


/***/ })

}]);